function initVideoQuoteBreakControls() {
  document.querySelectorAll(".video-quote-break").forEach(function (block) {
    var video = block.querySelector(".video-quote-break__media video");
    if (!video || block.querySelector(".video-quote-break__controls")) return;

    var controls = document.createElement("div");
    controls.className = "video-quote-break__controls";
    controls.innerHTML =
      '<button type="button" class="button button--outline button--pause video-quote-break__control" aria-pressed="false">' +
      '<span class="visually-hidden">Toggle Video Play</span>' +
      "</button>";

    block.insertBefore(controls, block.firstChild);

    var controlButton = controls.querySelector("button");

    controlButton.addEventListener("click", function () {
      if (controlButton.getAttribute("aria-pressed") === "false") {
        video.pause();
        controlButton.classList.remove("button--pause");
        controlButton.classList.add("button--play-alt");
        controlButton.setAttribute("aria-pressed", "true");
      } else {
        video.play();
        controlButton.classList.remove("button--play-alt");
        controlButton.classList.add("button--pause");
        controlButton.setAttribute("aria-pressed", "false");
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", initVideoQuoteBreakControls);
